import api from "../api";
import axios from "axios";
import { useGeolocation } from "@vueuse/core";

export default {
  namespaced: true,
  state: {
    feesData: [],
    applicationCountry: "",
    ip: null,
    isEgypt: null,
    // paymentURL: "",
  },
  getters: {
    getFeesData(state) {
      return state.feesData;
    },
    getApplicationCountry(state) {
      return state.applicationCountry;
    },
    getIP(state) {
      return state.ip;
    },
  },
  mutations: {
    setFeesData(state, data) {
      state.feesData = [];
      for (var x = data.length - 1; x >= 0; x--) {
        state.feesData.push({
          feeDescr: data[x].feeDescr,
          feeAmount: data[x].feeAmount,
          feeRemainAmount: data[x].feeRemainAmount,
          isPaid: data[x].isPaid,
          currency: data[x].currencyDescr,
        });
      }
    },

    setApplicationCountry(state, data) {
      state.applicationCountry = data.country;
      // state.applicationCountry = "Egypt";
    },
    setIP(state, data) {
      state.ip = data;
    },
    // setPaymentUrl(state, data) {
    //     state.paymentURL = data.url;
    // },
  },
  actions: {
    fetchFeesData({ commit, state }) {
      return new Promise((resolve, reject) => {
        api()
          .get(`api/v1/ApplicantFees/GetAllApplicantFees`, {
            params: {
              isEgypt: state.isEgypt, // Send isEgypt in the API call
            },
          })
          .then((res) => {
            commit("setFeesData", res.data.allApplicantFees);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    async fetchApplicationCountry({ commit, dispatch, state }) {
      // Define multiple IP geolocation services with their response formats
      const ipServices = [
        {
          url: "https://ipapi.co/json/",
          parser: (data) => ({
            country: data.country_code,
            countryName: data.country_name,
            city: data.city,
            region: data.region,
            ip: data.ip,
          }),
        },
        {
          url: "https://ipinfo.io/json",
          parser: (data) => ({
            country: data.country,
            countryName: data.country,
            city: data.city,
            region: data.region,
            ip: data.ip,
          }),
        },
        {
          url: "https://api.ipgeolocation.io/ipgeo?apiKey=free",
          parser: (data) => ({
            country: data.country_code2,
            countryName: data.country_name,
            city: data.city,
            region: data.state_prov,
            ip: data.ip,
          }),
        },
        {
          url: "https://freegeoip.app/json/",
          parser: (data) => ({
            country: data.country_code,
            countryName: data.country_name,
            city: data.city,
            region: data.region_name,
            ip: data.ip,
          }),
        },
      ];

      // Try each IP service sequentially
      for (const service of ipServices) {
        try {
          console.log(`Trying IP service: ${service.url}`);
          const response = await axios.get(service.url, {
            timeout: 5000, // 5 second timeout per service
          });

          const countryData = service.parser(response.data);

          if (countryData.country) {
            commit("setApplicationCountry", countryData);
            state.isEgypt = countryData.country === "EG" ? 1 : 0;
            console.log(`Successfully got location from: ${service.url}`);
            return; // Success, exit function
          }
        } catch (error) {
          console.warn(`IP service ${service.url} failed:`, error.message);
          continue; // Try next service
        }
      }

      // If all IP services fail, try multiple geolocation approaches
      try {
        console.log("All IP services failed, trying geolocation approaches...");

        let latitude, longitude;

        // Try native browser geolocation first
        try {
          console.log("Trying native browser geolocation...");
          const position = await new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
              reject(new Error("Geolocation not supported"));
              return;
            }

            navigator.geolocation.getCurrentPosition(
              (pos) => resolve(pos),
              (error) => reject(error),
              {
                enableHighAccuracy: true,
                timeout: 8000,
                maximumAge: 60000,
              }
            );
          });

          latitude = position.coords.latitude;
          longitude = position.coords.longitude;

          // Validate native geolocation coordinates
          if (
            !isFinite(latitude) ||
            !isFinite(longitude) ||
            latitude < -90 ||
            latitude > 90 ||
            longitude < -180 ||
            longitude > 180
          ) {
            throw new Error(
              `Invalid native coordinates: lat=${latitude}, lng=${longitude}`
            );
          }

          console.log(
            `Native geolocation success: lat=${latitude}, lng=${longitude}`
          );
        } catch (nativeError) {
          console.warn("Native geolocation failed:", nativeError.message);

          // Fallback to VueUse geolocation
          try {
            console.log("Trying VueUse geolocation...");
            const {
              coords,
              locatedAt,
              error: geoError,
              resume,
            } = useGeolocation({
              enableHighAccuracy: false, // Try with lower accuracy first
              timeout: 8000,
              maximumAge: 60000,
            });

            resume();

            // Wait for coordinates with better error handling
            await new Promise((resolve, reject) => {
              let attempts = 0;
              const maxAttempts = 80; // 8 seconds with 100ms intervals

              const checkCoords = () => {
                attempts++;

                if (geoError.value) {
                  reject(
                    new Error(
                      `VueUse geolocation error: ${geoError.value.message}`
                    )
                  );
                  return;
                }

                if (
                  coords.value &&
                  coords.value.latitude &&
                  coords.value.longitude
                ) {
                  // Additional validation for VueUse coords
                  if (
                    isFinite(coords.value.latitude) &&
                    isFinite(coords.value.longitude)
                  ) {
                    resolve();
                    return;
                  } else {
                    reject(
                      new Error(
                        `VueUse returned invalid coordinates: lat=${coords.value.latitude}, lng=${coords.value.longitude}`
                      )
                    );
                    return;
                  }
                }

                if (attempts >= maxAttempts) {
                  reject(
                    new Error(
                      "VueUse geolocation timeout - no valid coordinates received"
                    )
                  );
                  return;
                }

                setTimeout(checkCoords, 100);
              };

              checkCoords();
            });

            latitude = coords.value.latitude;
            longitude = coords.value.longitude;
            console.log(
              `VueUse geolocation success: lat=${latitude}, lng=${longitude}`
            );
          } catch (vueUseError) {
            console.warn(
              "VueUse geolocation also failed:",
              vueUseError.message
            );
            throw new Error("All geolocation methods failed");
          }
        }

        // Final coordinate validation
        if (
          !latitude ||
          !longitude ||
          !isFinite(latitude) ||
          !isFinite(longitude) ||
          latitude < -90 ||
          latitude > 90 ||
          longitude < -180 ||
          longitude > 180
        ) {
          throw new Error(
            `Final validation failed - Invalid coordinates: lat=${latitude}, lng=${longitude}`
          );
        }

        console.log(
          `Using validated coordinates: lat=${latitude}, lng=${longitude}`
        );

        // Multiple reverse geocoding services
        const geocodingServices = [
          {
            url: `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`,
            parser: (data) => ({
              country: data.countryCode,
              countryName: data.countryName,
              city: data.city,
              region: data.principalSubdivision,
            }),
          },
          {
            url: `https://geocode.xyz/${latitude},${longitude}?json=1`,
            parser: (data) => ({
              country: data.prov,
              countryName: data.country,
              city: data.city,
              region: data.region,
            }),
          },
          {
            url: `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=free&limit=1`,
            parser: (data) => {
              const result = data.results[0];
              return {
                country: result?.components?.country_code?.toUpperCase(),
                countryName: result?.components?.country,
                city: result?.components?.city || result?.components?.town,
                region: result?.components?.state,
              };
            },
          },
        ];

        // Try each geocoding service
        for (const service of geocodingServices) {
          try {
            console.log(`Trying geocoding service: ${service.url}`);
            const geocodeResponse = await axios.get(service.url, {
              timeout: 5000,
            });

            const locationData = service.parser(geocodeResponse.data);

            if (locationData.country) {
              const countryData = {
                ...locationData,
                ip: null, // Not available with geolocation
                latitude: latitude,
                longitude: longitude,
                locatedAt: locatedAt.value,
              };

              commit("setApplicationCountry", countryData);
              state.isEgypt = locationData.country === "EG" ? 1 : 0;
              console.log(
                `Successfully got location from geocoding: ${service.url}`
              );
              return; // Success, exit function
            }
          } catch (geocodeError) {
            console.warn(
              `Geocoding service failed: ${service.url}`,
              geocodeError.message
            );
            continue; // Try next service
          }
        }

        throw new Error("All geocoding services failed");
      } catch (fallbackError) {
        console.error("Geolocation also failed:", fallbackError);

        // Final fallback: set default values
        const defaultCountryData = {
          country: "Unknown",
          countryName: "Unknown",
          city: "Unknown",
          region: "Unknown",
          ip: null,
        };

        commit("setApplicationCountry", defaultCountryData);
        state.isEgypt = 0; // Default to non-Egypt
      }
    },

    fetchPaymentURL({ _ }) {
      return new Promise((resolve, reject) => {
        api()
          .get(`api/v1/NBEPay`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchFawryPaymentURL({ _ }) {
      return new Promise((resolve, reject) => {
        api()
          .get(`api/v1/FawryPay`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkForPayment({ _ }, paid) {
      return new Promise((resolve, reject) => {
        api()
          .get(`/api/v1/NBEPaymentStatement?IsPaid=${paid}`)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkForFawryPayment({ _ }) {
      return new Promise((resolve, reject) => {
        api()
          .get(`/api/v1/FawryPayStatment`)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
